import { HttpClient, HttpMethod, HttpStatusCode } from '@hub-la/fe-core-http-client'
import { inject } from 'inversify'
import { AddDailyCreditsInput } from '../domain/dtos/add-daily-credits-input'
import { GeneralError } from '../domain/errors/general'
import { Envs } from '../envs'

export class AddDailyCredits {
  public constructor(@inject(HttpClient) private readonly httpClient: HttpClient) {}

  public async execute(data: AddDailyCreditsInput): Promise<void> {
    const response = await this.httpClient.request({
      method: HttpMethod.PUT,
      url: `${Envs.BFF_WEB_URL}/subscriptions/${data.id}/add-daily-credits`,
      body: data,
    })

    if ([HttpStatusCode.OK, HttpStatusCode.CREATED].includes(response.statusCode)) {
      return response.data
    } else {
      /** @todo: Handle backend errors */
      throw new GeneralError()
    }
  }
}
